import React, { useEffect, useRef } from 'react';

const Social = () => {
  const timelineRef = useRef(null);

  useEffect(() => {
    // Add the script only if not present
    if (!window.twttr) {
      const script = document.createElement('script');
      script.src = 'https://platform.twitter.com/widgets.js';
      script.async = true;
      script.onload = () => {
        if (window.twttr && timelineRef.current) {
          window.twttr.widgets.load(timelineRef.current);
        }
      };
      document.body.appendChild(script);
    } else if (window.twttr && timelineRef.current) {
      window.twttr.widgets.load(timelineRef.current);
    }
  }, []);

  return (
    <div>
      <div ref={timelineRef}>
        <a
          className="twitter-timeline"
          href="https://twitter.com/RLCofVA?ref_src=twsrc%5Etfw"
        >
          Tweets by RLCofVA
        </a>
      </div>
      <hr />
    </div>
  );
};

export default Social;